document.documentElement.classList.add('wh-aiig-page');
document.body.classList.add('wh-aiig-page');

document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* 首页导航锚点修复：等待板块排序完成后再滚动 */
(function () {
  var homeAnchorIds = ['wh-system-includes', 'wh-course-path'];

  function scrollToHomeSection(id, behavior) {
    if (homeAnchorIds.indexOf(id) === -1) return;

    var target = document.getElementById(id);
    if (!target) return;

    target.scrollIntoView({
      behavior: behavior || 'smooth',
      block: 'start'
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href="/wh-system-includes"], a[href="/wh-course-path"]'
    );

    if (!link) return;

    /* 不在首页时，让浏览器正常回到首页 */
    if (window.location.pathname !== '/') return;

    var targetId = link.hash.replace('#', '');
    var target = document.getElementById(targetId);

    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', '#' + targetId);

    window.setTimeout(function () {
      scrollToHomeSection(targetId, 'smooth');
    }, 50);
  });

  /* 从其他页面进入带锚点的首页时，再次校正位置 */
  window.addEventListener('load', function () {
    var targetId = window.location.hash.replace('#', '');

    if (homeAnchorIds.indexOf(targetId) === -1) return;

    window.setTimeout(function () {
      scrollToHomeSection(targetId, 'auto');
    }, 300);
  });
})();

/* 54个案例自动纵向循环轮播 */
(function () {
  function initWhCaseCarousel() {
    var viewport = document.querySelector(
      "#wh-case-subscribe .wh-case-library-viewport"
    );

    var track = document.querySelector(
      "#wh-case-subscribe #wh-case-library-track"
    );

    var group = track
      ? track.querySelector(".wh-case-library-group")
      : null;

    if (!viewport || !track || !group) return;

    if (track.getAttribute("data-wh-carousel-ready") === "true") {
      return;
    }

    var rowCount = group.querySelectorAll(
      ".wh-case-library-row"
    ).length;

    if (rowCount < 2) return;

    track.setAttribute("data-wh-carousel-ready", "true");

    /* 复制一组案例，实现首尾无缝衔接 */
    var clonedGroup = group.cloneNode(true);
    clonedGroup.setAttribute("aria-hidden", "true");
    track.appendChild(clonedGroup);

    /* 每个案例约停留/经过3秒，数量增加后自动调整总时长 */
    track.style.setProperty(
      "--wh-case-carousel-duration",
      Math.max(30, rowCount * 3) + "s"
    );

    track.classList.add("wh-case-library-track--auto");
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initWhCaseCarousel
    );
  } else {
    initWhCaseCarousel();
  }

  document.addEventListener(
    "shopify:section:load",
    initWhCaseCarousel
  );
})();